<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'成果展示管理'},{name:'成果展示列表'}]" :title="'成果展示列表'"/> -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="全平台" name="0"></el-tab-pane>
              <el-tab-pane label="蓉易贷" name="1"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <el-button type="primary" size="small" @click="edit()" icon="el-icon-plus">添加</el-button>
                </div>
                <div class="right">
                   
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="bankName"
                    show-overflow-tooltip
                    label="银行名称">
                </el-table-column>
                
                <template v-if="tab === '0'">
                    <el-table-column
                    prop="amount"
                    show-overflow-tooltip
                    label="产品数量">
                </el-table-column>
                <el-table-column
                    prop="acceptAmount"
                    show-overflow-tooltip
                    label="交易成功笔数">
                </el-table-column>
                <el-table-column
                    prop="moneyAmount"
                    show-overflow-tooltip
                    label="撮合交易金额">
                </el-table-column>
                </template>
                <template v-else>
                  <el-table-column
                    prop="amount"
                    show-overflow-tooltip
                    label="放款户数">
                </el-table-column>
                <el-table-column
                    prop="acceptAmount"
                    show-overflow-tooltip
                    label="放款笔数">
                </el-table-column>
                <el-table-column
                    prop="moneyAmount"
                    show-overflow-tooltip
                    label="放款金额">
                </el-table-column>
                </template>
                
                <el-table-column
                    label="操作"
                    
                    width="180">
                    <template slot-scope="scope">
                        <!-- <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)">查看</el-button> -->
                        <el-button size="small" type="primary" class="super" plain  @click="edit(scope.row)">编辑</el-button>
                        <el-button size="small" type="danger" class="super" plain  @click="del(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
           
            
        </div>
</template>

<script>

// import breadcrumb from '../../components/breadcrumb';
import {getDict} from "@/axios";
import timeMixins from "@/mixins/timeFormat";
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
          tab:'0',
            loading:false,
            bHeight: void 0,
            ishide:false,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
            options: [{
                value: '1',
                label: '公告ID'
            },{
                value: '2',
                label: '公告标题'
                }, {
                value: '3',
                label: '发布账号'
            },{
                value: '4',
                label: '更新账号'
            }],//检索下拉
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                property:void 0,
                direction:"DESC",
               type:0, // 类型（0=全平台、1=蓉易贷）
            },//检索提交数据
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            dialogAudit:false,//更新进度弹出层
            sendInfoTwo:{
                applyId:'',//id
                rate:'',//担保进度
                amount:'',//是否已放款选择值
                dealWithRemark:'',//说明
            },
            isSelect:'1',
            totalSize:null,
            statusList:[],
            scopeList:[],
            detailInfo:{
                applicant:"",
                contactPhone:"",
                applyCompany:"",
                applyRemark:"",
                fileList:[],
                createTime:"",
                amount:"",
                checkExplanation:"",
                modifyUserName:"",
                updateTime:""
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfoTwo.rate':{
            test:function(){
                if(this.sendInfoTwo.rate){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择担保进度'
        },
        'isSelect':{
            test:function(){
                if(this.isSelect){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择是否已放款'
        },
        'sendInfoTwo.amount':{
            test:function(){
                if(this.isSelect == 1){
                    return true
                }else{
                    if(this.sendInfoTwo.amount){
                        return true;
                    }else{
                        return false;
                    }
                }
                
            },
            message:'输入放款金额'
        },
    },
    methods:{
      changeTab: function (tab) {
                this.tab = tab.name
                this.getData();
            },
            //删除按钮
        del:function(row){
            this.$confirm('是否删除？', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axiosc.delete('/backstage/achievementDisplay/del/'+row.id).then((r)=>{
                    if(r.code==200){
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getData();
                    }else{
                        this.$alert(r.msg);
                    }
                })
            }).catch(() => {});
        },
      //发布 编辑
        edit:function(row){
            if(row){//编辑
                this.$router.push({path:`/achievementsManagement/edit/${this.tab}/${row.id}`,query:{index:'/achievementsManagement'},params:{id:row.id,tab:this.tab}})
            }else{//发布
                this.$router.push({path:`/achievementsManagement/add/${this.tab}`,query:{index:'/achievementsManagement'},params:{tab:this.tab}})
            }
        },
      //表格下架,上架按钮
        soldOut:function(row){
		    let btnValue=row.btnValue;
            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                  const param = {
                    id:row.id,
                    putawayStatus:row.putawayStatus === 0?1:0
                  }
                    this.$axioscBody.post('/backstage/announcement/batchPutawayAnn',param).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: btnValue+'成功!'
                            });
                            this.getData();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
                }).catch(() => {
            });
        },
      onReset(){
            const param= {
                currentPage:1,//当前页
                pageSize:10,//页条数
                property:void 0,
                direction:"DESC",
                 type: parseInt(this.tab), // 类型（0=全平台、1=蓉易贷）
            }
            this.sendInfoOne = Object.assign(this.sendInfoOne,param)
            this.dateS = void 0
            this.getSelect = void 0
            this.getValue = void 0
            this.onSearch()
      },
      onSearch(){
        let lookData=this.dateS;
			if(lookData&&lookData.length>0){
				this.sendInfoOne.startDate=lookData[0];
				this.sendInfoOne.endDate=lookData[1];
			}else {
          this.sendInfoOne.startDate=null;
          this.sendInfoOne.endDate=null;
      }
			// 检索值
			let lookdell= parseInt(this.getSelect);
			this.sendInfoOne.id= void 0;
			this.sendInfoOne.createUserName= void 0;
			this.sendInfoOne.modifyUserName= void 0;
      this.sendInfoOne.title = void 0;
      // this.sendInfo.checkType = this.checkType
			if(lookdell==1){
				this.sendInfoOne.id=this.getValue;
			}else if(lookdell==2){
				this.sendInfoOne.title=this.getValue;
			}else if(lookdell==3){
        this.sendInfoOne.createUserName=this.getValue;
      }else{
				this.sendInfoOne.modifyUserName=this.getValue;
			}
      this.getData()
      },
       doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //表格查看按钮
        check:function(row){
            if(row.vouchName == '经开区中小担'){
                this.ishide = true
            }else{
                this.ishide = false
            }
            // this.$axiosc.get('backstage/vouch/apply/details/'+row.id).then(res=>{
            //     if(res.code == 200){
            //         this.detailInfo = res.data
            //          this.dialogInfo=true;
            //     }else{
            //         this.$message({
            //             type: 'error',
            //             message: res.msg
            //         });
            //     }
            // })
            this.$router.push({path: `/partnerManagement/notice/detail/${row.id}`, query: {index: '/partnerManagement/notice',ishide:this.ishide},param:{id:row.id}})
        },
        //表格更新进度
        updateProgress:function(row){
            this.sendInfoTwo.applyId = row.id
            this.sendInfoTwo.rate = ''//担保进度
            this.sendInfoTwo.amount=''//是否已放款选择值
            this.sendInfoTwo.dealWithRemark=''//说明
            this.dialogAudit=true;
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axiosc.put('backstage/vouch/update/progress',this.$qs.stringify(this.sendInfoTwo)).then(res=>{
                    if(res.code == 200){
                        this.getData()
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.dialogAudit=false
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        getData(){
            this.loading = true
            const param = {...this.sendInfoOne}
            param.type = parseInt(this.tab)
            this.$axiosc.get('/backstage/achievementDisplay/list',{params:param}).then(res=>{
                this.loading = false
                if(res.code==200){
                    this.tableData=res.data.content;
                    this.totalSize=res.data.totalElements;
                }else{
                    this.$alert(res.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        }
    },

    mounted(){
        const that = this
        // getDict('isShow/VOUCH_RATE').then(data=>{
        //     that.statusList = data['isShow/VOUCH_RATE']
        // })
         // 请求
        that.getData();
        let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 70
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 70
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>
.main{
  padding-top:10px;
  .retrieve{
    flex-direction:row;
  }
}
.forms .child .el-input{
  max-width:100% !important;
}
</style>